<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/p13.jpg"/><a id="page_13"></a></p><a id="page_13">
<p class="fm1"><b>Tina Kashlak Nicolai, PHR, CPBA, CARW Resume Writer’s Ink</b></p>
<p class="txc">(407) 578-1697</p>
</a><p class="txc"><a id="page_13"></a><a href="mailto:tina@resumewritersink.com" id="AQn">tina@resumewritersink.com</a></p>
<p class="txc"><a href="http://www.resumewritersink.com" id="AYd" target="_blank">www.resumewritersink.com</a></p>
<p class="txc"><a href="http://www.linkedin.com/in/tinakashlaknicolai" id="AxA" target="_blank">www.linkedin.com/in/tinakashlaknicolai</a></p>
<p class="txc"><a href="http://www.facebook.com/resumewritersink" id="An" target="_blank">www.facebook.com/resumewritersink</a></p>
<p class="txc">Twitter: @tinanicolai</p>
<p class="tx2">Resume Writers’ Ink was founded in 2010 by Tina Kashlak Nicolai. She offers her clients a strategic, trifecta approach by combining her unique background weaving together pragmatic client results with creative marketing.</p>
<p class="tx2">Tina’s trifecta approach comes from having a tenured career:</p>
<p class="hangul">• Hiring leader for several Fortune 100 companies (including Disney World)</p>
<p class="hangul">• Full cycle recruiter (20+ years and currently working in talent acquisition)</p>
<p class="hangul">• Journalist and Marketing expertise</p>
<p class="tx2">Tina holds two degrees from Duquesne University in Pittsburgh, PA; BA Journalism and BA Media Communications. Additionally, she holds the following certifications:</p>
<p class="hangul">• Certified Behavioral Coach, CPBA</p>
<p class="hangul">• Lominger/Korn Ferry Certification</p>
<p class="hangul">• Certified Advanced Resume Writer, CARW</p>
<p class="hangul">• PHR SHRM</p>
<p class="tx2">Additionally, Tina is sought out on an ongoing basis by leading industry career journalists and media where she contributes best practices, tips, and advice in major media streams, including, Business Insider Careers, Forbes Careers, International radio groups, and Monster Careers. She’s been featured in numerous book publications as well as sought out for keynote speaking and career motivation talks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter14.vue?90232df0